import * as React from "react";
import Svg, { Circle, G, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={15} cy={15} r={15} fill="#00AB59" fillOpacity={0.1} />
      <G clipPath="url(#clip0_9124_16656)">
        <Path
          d="M9.675 19.052a.78.78 0 00.114-.01l3.191-.56a.185.185 0 00.1-.052l8.043-8.043a.19.19 0 000-.268L17.97 6.964a.188.188 0 00-.135-.055.188.188 0 00-.134.055l-8.043 8.043a.192.192 0 00-.053.1l-.56 3.192a.636.636 0 00.178.565.643.643 0 00.452.188zm1.279-3.31l6.881-6.879 1.391 1.391-6.881 6.88-1.687.297.296-1.688zm10.528 4.904H7.518a.606.606 0 00-.607.607v.683c0 .083.068.152.151.152h14.875a.152.152 0 00.152-.152v-.683a.606.606 0 00-.607-.607z"
          fill="#000"
          fillOpacity={0.85}
        />
      </G>
      <Defs>
        <ClipPath id="clip0_9124_16656">
          <Path fill="#fff" transform="translate(6 6)" d="M0 0H17V17H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
